import { getSkillLogo } from './skillLogos';

/** Skill categories — ordered: fundamentals → frameworks → specialized tools */
export const skillCategoryDefinitions = [
  {
    category: 'Frontend',
    description: 'Building beautiful, interactive user interfaces.',
    skills: [
      'HTML5',
      'CSS3',
      'JavaScript',
      'TypeScript',
      'React',
      'Next.js',
      'Redux',
      'Tailwind CSS',
      'Bootstrap',
      'Leaflet.js',
    ],
  },
  {
    category: 'Backend',
    description: 'Server-side logic, APIs, and business rules.',
    skills: [
      'Node.js',
      'Express.js',
      'NestJS',
      'Python',
      'PHP',
      'Java',
      'Next.js API',
      'RESTful API',
      'JWT Auth',
      'Socket.io',
      'Webhooks',
      'Nodemailer',
      'Twilio',
      'Stripe API',
      'Selenium',
      'AI API Integrations',
      'Weather APIs',
    ],
  },
  {
    category: 'Database',
    description: 'Data modeling, storage, and management.',
    skills: ['MongoDB', 'PostgreSQL', 'MySQL', 'SQLite', 'Redis'],
  },
  {
    category: 'Mobile',
    description: 'Cross-platform mobile app development.',
    skills: ['Flutter', 'Dart', 'React Native', 'Expo', 'Firebase'],
  },
  {
    category: 'Tools & Design',
    description: 'Development tools and design systems.',
    skills: [
      'Git',
      'GitHub',
      'Figma',
      'VS Code',
      'Postman',
      'Chrome DevTools',
      'Android Studio',
      'XAMPP',
      'PyQt5',
      'PyInstaller',
    ],
  },
  {
    category: 'DevOps & Cloud',
    description: 'Deployment, automation, and cloud infrastructure.',
    skills: ['Docker', 'Nginx', 'GitHub Actions', 'AWS', 'VPS Deployment'],
  },
];

export const skillCategories = skillCategoryDefinitions.map((cat) => ({
  ...cat,
  skills: cat.skills.map((title) => ({
    title,
    logo: getSkillLogo(title),
  })),
}));
